import React, { createContext, useContext, useState, useEffect } from 'react';

// Common translations for hardcoded parts of the site
export const translations = {
  tr: {
    nav: {
      about: 'felsefem',
      projects: 'projeler',
      works: 'yetenekler',
      skills: 'program',
      universe: 'evren',
      contact: 'iletişim'
    },
    hero: {
      create: 'YARAT',
      digital: 'DİJİTAL',
      experiences: 'DENEYİMLER',
      line1: 'YARAT',
      line2: 'DİJİTAL',
      line3: 'DENEYİMLER'
    },
    awards: {
      subtitle: '© Araçlar & Yetkinlik',
      title: 'Yetenekler & Araçlar',
      desc: 'Karta tıklayarak detayları görüntüle.'
    },
    projects: {
      view_project: 'Projeyi Gör',
      add_yours: 'Kendi projenizi bu listeye ekleyin',
      label: 'projeler'
    },
    program: {
      subtitle: 'EĞİTİM PROGRAMI',
      title: 'Yetenek Seviyeleri',
      desc: 'Bu kurs tasarımcılar için tasarımcılar tarafından oluşturuldu. Becerilerinizi festival seviyesine çıkaracağız.',
      months: 'ay',
      features: [
        { title: 'Blender', desc: 'Orta' },
        { title: 'Photoshop', desc: 'Orta' },
        { title: 'İlgili Beceriler', desc: '3D modelleme, animasyon, proje yönetimi ve tasarım koruması hakkında dersler.' },
        { title: 'Sürekli Destek', desc: 'Öğreniminizi gerçekten faydalı kılmak için sürekli destek ve haftalık geri bildirim.' },
        { title: 'Uluslararası Yarışmalar', desc: 'Uluslararası tasarım yarışmalarına ve festivallerine katılma fırsatı.' }
      ],
      stats: [
        { label: 'Dersler', sub: '40 saat' },
        { label: 'Grup Oturumları', sub: '30+ saat' },
        { label: 'Bireysel Oturumlar', sub: '4+ saat' }
      ]
    },
    contact: {
      contact_badge: 'BAŞVURU YAP (BEKLEME LİSTESİ)',
      contact_heading: 'KNOXOPIA SİZİ WEB TASARIMIN GERÇEK DÜNYASIYLA TANIŞTIRACAK.',
      contact_success_title: 'Başvuru Gönderildi!',
      contact_success_desc: 'İlginiz için teşekkürler. Başvurunuzu inceleyip en kısa sürede geri döneceğiz.',
      contact_greeting: "MERHABA, KNOXOPIA'_!",
      contact_field_name: 'Benim adım',
      contact_placeholder_name: 'Adınız',
      contact_field_email: 'E-posta adresim',
      contact_placeholder_email: 'sen@eposta.com',
      contact_field_instagram: 've instagramım',
      contact_field_portfolio: 'Portfolyo linkim',
      contact_privacy_text: 'Gizlilik politikasını kabul ediyorum ve başvurumla ilgili iletişime geçilmesine onay veriyorum.',
      contact_btn_label: 'Gönder',
      sending: 'Gönderiliyor...',
      socials: 'Bizi bulun',
      email_label: 'e-posta'
    },
    footer: {
      rights: 'Tüm hakları saklıdır.',
      backToTop: 'Başa Dön',
      privacy: 'Gizlilik Politikası',
      terms: 'Kullanım Koşulları'
    },
    philosophy: {
      subtitle: '© HIKAYEMIZ',
      title: 'Yaratıcı Vizyon',
      line1: 'KNOXOPIA sadece bir tasarım stüdyosu değil, dijital dünyada yeni bir soluktur.',
      line2: 'Her pikselde bir hikaye, her projede bir gelecek vizyonu saklıdır.',
      line3: 'MENTÖRLERİNİZ,',
      line4: 'VE İŞ ORTAKLARINIZ.',
      para1: 'Tasarım anlayışımız, estetik ve işlevselliği en modern teknolojilerle birleştirerek kullanıcıya benzersiz bir deneyim sunmaktır.',
      para2: '2026 vizyonumuzla, sınırları zorlayan projelere imza atmaya devam ediyoruz.',
      as_seen_on: 'as seen on',
      logo_here: 'logo buraya'
    },
    gallery: {
      subtitle: '© GÖRSEL ARŞİV',
      title: 'Galeri & Süreç',
      desc: 'Eğitiminiz boyunca tüm KNOXOPIA ekibinin çalışmalarına dahil olacak ve bunun bir parçası olacaksınız, pratik deneyim kazanacaksınız.',
      bg_text: "KNOXOPIA SRG'_"
    },
    projectDetail: {
      back: 'Projelere Dön',
      close: '[ Kapat ]',
      prev: '← Önceki',
      next: 'Sonraki →',
      notFound: 'Proje bulunamadı',
      author: 'Ekip / Yazar',
      client: 'Müşteri',
      year: 'Yıl',
      categories: 'Kategoriler',
      view_live: 'Projeyi Görüntüle →',
      no_desc: 'Açıklama eklenmemiş',
      images_label: 'Görseller',
      all_projects: '← Tüm Projeler',
      contact: 'İletişime Geç →'
    },
    projectsPage: {
      subtitle: 'Visual Repository',
      title1: 'Project',
      title2: 'Archive',
      all_filter: '[ All ]',
      not_found: 'Proje bulunamadı',
      view_details: 'Detayları Gör',
      contact_btn: 'İletişime Geç',
      end_of_archive: 'Arşivin Sonu'
    },
    services: {
      label: 'Hizmetler',
      title: 'Ne Yapıyoruz',
      subtitle: 'Yaratıcı stüdyomuzun sunduğu hizmetler',
      svc1_title: '2D Çalışmalar',
      svc1_subtitle: 'Görsel Tasarım',
      svc1_items: 'Albüm & Şarkı Kapakları, Tek Kare Renderlar, Poster Tasarımı, Sosyal Medya Görselleri',
      svc2_title: '3D Çalışmalar',
      svc2_subtitle: 'Dijital Sanat',
      svc2_items: '3D Video, DJ Visuals, VFX, Motion Graphics',
      svc3_title: 'Branding',
      svc3_subtitle: 'Kimlik Tasarımı',
      svc3_items: 'Logo Tasarımı, Kurumsal Kimlik, Marka Rehberi, Ambalaj Tasarımı'
    }
  },
  en: {
    nav: {
      about: 'about',
      projects: 'projects',
      works: 'works',
      skills: 'skills',
      universe: 'universe',
      contact: 'contact'
    },
    hero: {
      create: 'CREATE',
      digital: 'DIGITAL',
      experiences: 'EXPERIENCES',
      line1: 'CREATE',
      line2: 'DIGITAL',
      line3: 'EXPERIENCES'
    },
    awards: {
      subtitle: '© Tools & Competence',
      title: 'Skills & Tools',
      desc: 'Click on card to see details.'
    },
    projects: {
      view_project: 'View Project',
      add_yours: 'Add your project to this list',
      label: 'projects'
    },
    program: {
      subtitle: 'training program',
      title: 'Skill Levels',
      desc: 'This course was created by designers for designers. We will pump up your skills to festival level.',
      months: 'months',
      features: [
        { title: 'Blender', desc: 'Mid' },
        { title: 'Photoshop', desc: 'Mid' },
        { title: 'Related skills', desc: 'Lectures on 3D modeling, animation, project management, and design protection.' },
        { title: 'Ongoing support', desc: 'Continuous support and weekly feedback to make your learning truly useful.' },
        { title: 'International competitions', desc: 'Opportunity to participate in international design competitions and festivals.' }
      ],
      stats: [
        { label: 'Lectures', sub: '40 hours' },
        { label: 'Group Sessions', sub: '30+ hours' },
        { label: 'Personal Sessions', sub: '4+ hours' }
      ]
    },
    contact: {
      contact_badge: 'submit an application ( waiting list )',
      contact_heading: 'KNOXOPIA will introduce you to the real world of web design.',
      contact_success_title: 'Application Sent!',
      contact_success_desc: "Thank you for your interest. We'll review your application and get back to you soon.",
      contact_greeting: "HELLO, KNOXOPIA'_!",
      contact_field_name: 'My name is',
      contact_placeholder_name: 'Your name',
      contact_field_email: 'My email',
      contact_placeholder_email: 'your@email.com',
      contact_field_instagram: 'and my instagram',
      contact_field_portfolio: 'Link to my portfolio',
      contact_privacy_text: 'I agree with the privacy policy and consent to being contacted regarding my application.',
      contact_btn_label: 'Send',
      sending: 'Sending...',
      socials: 'find us',
      email_label: 'e-mail'
    },
    footer: {
      rights: 'All rights reserved.',
      backToTop: 'Back to Top',
      privacy: 'Privacy Policy',
      terms: 'Terms of Use'
    },
    philosophy: {
      subtitle: '© OUR STORY',
      title: 'Creative Vision',
      line1: 'KNOXOPIA is not just a design studio, it is a new breath in the digital world.',
      line2: 'Every pixel hides a story, every project hides a vision of the future.',
      line3: 'MENTORS,',
      line4: 'AND BUSINESS PARTNERS.',
      para1: 'Our design approach is to provide a unique experience to the user by combining aesthetics and functionality with the most modern technologies.',
      para2: 'With our 2026 vision, we continue to carry out projects that push the limits.',
      as_seen_on: 'as seen on',
      logo_here: 'your logo here'
    },
    gallery: {
      subtitle: '© VISUAL ARCHIVE',
      title: 'Gallery & Process',
      desc: 'During your training, you will immerse yourself in the work of the entire KNOXOPIA team and become part of it, gaining practical experience.',
      bg_text: "KNOXOPIA SRG'_"
    },
    projectDetail: {
      back: 'Back to Projects',
      close: '[ Close ]',
      prev: '← Previous',
      next: 'Next →',
      notFound: 'Project not found',
      author: 'Team / Author',
      client: 'Client',
      year: 'Year',
      categories: 'Categories',
      view_live: 'View Live Project →',
      no_desc: 'No description added',
      images_label: 'Images',
      all_projects: '← All Projects',
      contact: 'Get in Touch →'
    },
    projectsPage: {
      subtitle: 'Visual Repository',
      title1: 'Project',
      title2: 'Archive',
      all_filter: '[ All ]',
      not_found: 'Project not found',
      view_details: 'View Details',
      contact_btn: 'Get in Touch',
      end_of_archive: 'End of Archive'
    },
    services: {
      label: 'Services',
      title: 'What We Do',
      subtitle: 'Services offered by our creative studio',
      svc1_title: '2D Works',
      svc1_subtitle: 'Visual Design',
      svc1_items: 'Album & Song Covers, Single Frame Renders, Poster Design, Social Media Visuals',
      svc2_title: '3D Works',
      svc2_subtitle: 'Digital Art',
      svc2_items: '3D Video, DJ Visuals, VFX, Motion Graphics',
      svc3_title: 'Branding',
      svc3_subtitle: 'Identity Design',
      svc3_items: 'Logo Design, Corporate Identity, Brand Guide, Packaging Design'
    }
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(localStorage.getItem('lang') || 'en');
  const [apiTranslations, setApiTranslations] = useState({});

  useEffect(() => {
    localStorage.setItem('lang', lang);
  }, [lang]);

  useEffect(() => {
    const API = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';
    fetch(`${API}/settings`)
      .then(res => res.json())
      .then(data => {
        if (data.app_translations) {
          setApiTranslations(data.app_translations);
        }
      })
      .catch(console.error);
  }, []);

  const toggleLanguage = () => {
    setLang(prev => (prev === 'tr' ? 'en' : 'tr'));
  };

  const t = (section, key = null, fallback = null) => {
    // If no key, return the entire section object (useful for arrays or maps)
    if (key === null) {
      return apiTranslations?.[lang]?.[section] ?? translations[lang]?.[section] ?? translations.en?.[section] ?? {};
    }

    const apiVal = apiTranslations?.[lang]?.[section]?.[key];
    if (apiVal !== undefined && apiVal !== null) return apiVal;
    
    // Fallbacks
    return translations[lang]?.[section]?.[key] ?? fallback ?? translations.en?.[section]?.[key] ?? key;
  };

  return (
    <LanguageContext.Provider value={{ lang, toggleLanguage, t, apiTranslations }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
